<template>
     <div v-show="parent2Show">
        <Form ref="formItem" :model="formItem" style="max-width:600px" :rules="formValidate" :label-width="100">
            <Form-item label="项目名称" prop="bigname">
                <Input type="text" v-model="formItem.bigname" placeholder="请输入"></Input>
            </Form-item>
            <Form-item label="模板" prop="temid">
                <Select v-model="formItem.temid" placeholder="请选择">
                    <Option v-for="(item,index) in temidSel" :key="index" :value="item.temid">{{item.name}}</Option>
                </Select>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="submitFn('formItem')">提交</Button>
            </Form-item>
        </Form>
    </div>
</template>
<script>
    export default {
        data(){
            const storelistRegexp = (rule, value, callback) => {    //门店校验
                if(value != null && value != ''){
                    if(!/^[^\{\}\[\]]+(,[^\{\}\[\]]+)*$/.test(value)){
                        callback(new Error('门店包含特殊符号，请检查！'));
                    }else{
                        callback();
                    }
                }else{
                    callback(new Error('门店不能为空'));
                }
            };
            return{
                formItem:{
                    bigname:'',
                    temid:'',
                },
                temidSel:[],
                formValidate:{
                    bigname: [
                        { required: true, message: '项目名称不能为空', trigger: 'change' }
                    ],
                    temid: [
                        { required: true, type:'number', message: '请选择模板', trigger: 'change' }
                    ],
                },
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
            this.getTemidFn();
        },
        methods:{
            submitFn(name){
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if(valid){
                        _this.$http.post('/web/workorder/addBigWorkOrder',_this.formItem).then(function(res){
                            if(res.success){
                                _this.$Notice.success({
                                    title:'新建项目',
                                    desc:res.message
                                });
                                _this.$router.push({path:'/projectList'});
                            }else{
                                _this.$Notice.error({
                                    title:'新建项目',
                                    desc:res.message
                                });
                            }
                        }).catch(function(res){
                            _this.$Notice.error({
                                title:'新建项目',
                                desc:'数据请求失败'
                            });
                        });
                    }else{
                        _this.$Message.error('表单提交失败');
                    }
                });
            },
            getTemidFn(){
                var _this=this;
                this.$http.get('/web/template/getAllTemidName').then(function(res){
                    if(res.success){
                        _this.temidSel=res.data;
                    }else{
                        _this.$Notice.error({
                            title:'获取模板下拉',
                            desc:res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title:'获取模板下拉',
                        desc:'数据请求失败'
                    });
                });
            },
        },
    }
</script>
<style scoped>
    .hd{ background:#464c5b; color:#fff; }
    h3{ background:#dddee1; padding:2px 5px 2px 20px; line-height:30px; margin-top:-1px; }
</style>


// WEBPACK FOOTER //
// src/components/task/addProject.vue